import React, { FC } from 'react';
import { connect } from 'react-redux';

import { ReduxState } from 'app/redux/types';

import { selectSports } from '../../selectors/entries';
import { EntriesSports } from '../../types/entries';
import Sport from './Sport';

import styles from './Entries.module.scss';

// ---

type StoreProps = {
  sports: EntriesSports;
};

const Entries: FC<StoreProps> = ({ sports }) => {
  return (
    <div className={styles.container}
         data-test="entries-container">
      {sports.valueSeq().map((sport) => (
        <Sport key={sport.entity.id}
               sportId={sport.entity.id} />
      ))}
    </div>
  );
};

const mapStateToProps = (state: ReduxState): StoreProps => ({
  sports: selectSports(state),
});

export default connect(mapStateToProps)(Entries);
